import { ReactComponent as PromptIcon } from "../../Asset/promptIcon.svg";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import "./comfirmation.css";

const Comfirmation = () => {
  const navigate = useNavigate();
  const { profileData } = useContext(AuthContext);

  // Refresh the page once when the component is mounted
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem('confirmationRefreshed');
    
    if (!hasRefreshed) {
      sessionStorage.setItem('confirmationRefreshed', 'true');
      window.location.reload();
    }
    
    // Clean up when component unmounts
    return () => {
      // Reset the flag when leaving the page
      sessionStorage.setItem('confirmationRefreshed', 'false');
    };
  }, []);

  const handleNavigation = () => {
    // Reset the flag before navigating away
    sessionStorage.setItem('confirmationRefreshed', 'false');
    
    if (profileData?.role === "vesselOwner") {
      navigate("/dashboard");
    } else if (profileData?.role === "charterer") {
      navigate("/UpdatecustomerProfile");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="comfrim-container">
      <div className="header">
        <BlackVatugIcon />
      </div>

      <div className="card">
        <PromptIcon />
        <h3>Registration complete</h3>
        <p>
          Your documents are being reviewed. You will be sent a confirmation
          email.
        </p>
        <button onClick={handleNavigation}>Okay</button>
      </div>
    </div>
  );
};

export default Comfirmation;


